import axios from 'axios'
import { Message } from 'element-ui'
// import router from '@/router'

axios.defaults.timeout = 10000
axios.defaults.withCredentials = true
axios.defaults.baseURL = '/base-operation'

const instance = axios.create()

instance.interceptors.request.use((config) => config, (error) => {
  Message.error({ message: '请求超时！请查看当前网络环境或稍后再试！' })
  return Promise.reject(error)
})
instance.interceptors.response.use((response) => {
  if (response.status === 200) return response.data
  Message({ message: '后台接口无响应或数据错误', type: 'error' })
}, (error) => {
  let { message, response } = error
  if (response) {
    const { data } = response
    if (data.status === 401 || data?.message?.includes('未登陆') || data?.message?.includes('未登录')) {
      message = ''
      location.href = `/login?returnUrl=${ location.href }`
    } else {
      message = '后台接口无响应或数据错误'
    }
  }
  if (message) {
    Message({ message: error?.response?.data.message || '网络错误', type: 'error' })
  }
  return Promise.reject(error)
})

export default instance
